import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const ChannelsViewContainer = styled.div`
  display: flex;
  margin-left: ${246 * Screen.widthRatio}px;
`;

export default ChannelsViewContainer;
